import RemoteCall from "../util/RemoteCall";

const remoteCall = new RemoteCall("api/rolePerm");

const findUsersByRoleAsync = (param) => {
    return remoteCall.invoke("findUsersByRole", param);
};

const allRolesAsync = () => {
    return remoteCall.get("allRoles");
};

const addRoleAsync = (param) => {
    return remoteCall.invoke("addRole", param);
};

const updateRoleAsync = (param) => {
    return remoteCall.invoke("updateRole", param);
};

const deleteRoleAsync = (param) => {
    return remoteCall.invoke("deleteRole", param);
};

const findAllPermsAsync = () => {
    return remoteCall.get("findAllPerms");
};

const saveRolePermAsync = (param) => {
    return remoteCall.invoke("saveRolePerm", param);
};

const updateRoleDataPermAsync = (param) => {
    return remoteCall.invoke("updateRoleDataPerm", param);
};

const saveRoleCustomHospAsync = (param) => {
    return remoteCall.invoke("saveRoleCustomHosp", param);
};

const addUserRoleAsync = (param) => {
    return remoteCall.invoke("addUserRole", param);
};

const deleteUserRoleAsync = (param) => {
    return remoteCall.invoke("deleteUserRole", param);
};

const findAccessibleDistAsync = (param) => {
    return remoteCall.get("findAccessibleDist", param);
};

const findRolesByUserAsync = (param) => {
    return remoteCall.get("findRolesByUser", param);
};
const findRoleByIdAsync = (param) => {
    return remoteCall.get("findRoleById", param);
};

const getWholePermTreeAsync = () => {
    return remoteCall.get("getWholePermTree")
}
export default {
    findAccessibleDistAsync,
    findUsersByRoleAsync,
    allRolesAsync,
    addRoleAsync,
    updateRoleAsync,
    deleteRoleAsync,
    findAllPermsAsync,
    saveRolePermAsync,
    updateRoleDataPermAsync,
    saveRoleCustomHospAsync,
    addUserRoleAsync,
    deleteUserRoleAsync,
    findRolesByUserAsync,
    findRoleByIdAsync,
    getWholePermTreeAsync
};
